module.exports = __webpack_public_path__ + "static/media/bares-notables-de-buenos-aires.c70371a6.md";